import { render, staticRenderFns } from "./LegalDocumentContent_NaXp88.vue?vue&type=template&id=dbf1b9c8&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_NaXp88.vue?vue&type=style&index=0&id=dbf1b9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf1b9c8",
  null
  
)

export default component.exports